import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { profile } from '@/lib/queries/profiles'
import { safeRedirectPath } from '@/hooks/use-auth-actions'
import { Onboarding } from '@/features/onboarding'
import { nextOnboardingStep } from '@/features/onboarding/steps'

const searchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/(auth)/onboarding')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, location, search }) => {
    if (!context.auth.isAuthenticated || !context.auth.user) {
      throw redirect({ to: '/sign-in', search: { redirect: location.href } })
    }

    const currentProfile = await context.queryClient.query(
      profile.findOne(context.auth.user.id)
    )
    const step = nextOnboardingStep(currentProfile)
    if (!step) {
      throw redirect({ href: safeRedirectPath(search.redirect), replace: true })
    }

    return { step }
  },
  component: OnboardingPage,
})

function OnboardingPage() {
  const { step } = Route.useRouteContext()
  return <Onboarding step={step} />
}
